import {AfterViewInit, Component, inject, Input, PLATFORM_ID} from '@angular/core';

import {isPlatformBrowser, NgForOf, NgIf} from '@angular/common';
import {LimitPipe} from '../../../../common/pipe/limit.pipe';
import Swiper from 'swiper';
import {Autoplay} from 'swiper/modules';
import {StarsComponent} from '../../common/stars/stars.component';
import {SessionResources} from '../../../../resources/session.resources';

@Component({
  selector: 'app-session-testimonies',
  imports: [
    LimitPipe,
    NgForOf,
    NgIf,
    StarsComponent
  ],
  templateUrl: './session-testimonies.component.html',
})
export class SessionTestimoniesComponent implements AfterViewInit{

  platformId = inject(PLATFORM_ID);
  sessionResources = inject(SessionResources);

  swiper: Swiper

  @Input()
  city: string

  @Input()
  black = false

  async ngAfterViewInit() {

    if (isPlatformBrowser(this.platformId)) {
      setTimeout(() => {
        this.swiper = new Swiper(".testimonies-carousel", {
          loop: true,
          speed: 350,
          autoplay: {
            delay: 3000
          },
          pagination: {
            el: ".swiper-testimonies-pagination",
          },
          modules: [Autoplay],
        });
      }, 600)
    }

  }


}
